import {Remove} from 'components/grid-dx/consult-buttons/index';
import {Column} from 'devextreme-react/data-grid';
import {getAssistantAdded} from 'features/instance-manager/hooks';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import IntegrityRoleGrid from '../../../../components/UserRole';
import {i18n2} from '../../../i18n/i18n';
import {DELETE_COLLABORATOR, SET_COLLABORATOR} from '../../types/types';
import {CollaboAssistantSchema} from '../../assistants/model/Collaborator';
import {ProfCollaborator} from '../../assistants/model/ProfCollaborator';
import {getActionColumnWidth} from 'components/grid-dx/styles/actionButtonStyles';
import {useIsTablet} from 'components/hooks/useIsTablet';

interface CollaboratorAssistantGridProps {
  useSpac: boolean;
  iD_Instance: number;
  iD_Course: number;
  token: string;
}

const MAX_ACTION_BUTTONS = 1;

const Buttons = ({data}: any) => {
  return <Remove row={data} type={DELETE_COLLABORATOR} />;
};

const CollaboratorAssistantGrid = ({
  useSpac,
  iD_Instance,
  iD_Course,
  token,
}: CollaboratorAssistantGridProps) => {
  const dispatch = useDispatch();
  const isTablet = useIsTablet();
  const assistant = useSelector((state: any) => state.assistants.collaborator);

  useEffect(() => {
    const param = JSON.stringify({
      Key: 'Instance',
      Value: iD_Instance,
      id_course: iD_Course,
    });
    getAssistantAdded(param, token, useSpac).then(({data}: any) => {
      dispatch({type: SET_COLLABORATOR, payload: data});
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IntegrityRoleGrid
      allowActions={false}
      hideToolbar
      allowIntegrity={false}
      height={'40vh'}
      marginBottom={'0'}
      rowId={useSpac ? ['employee_Nr', 'iD_ProfileSpac'] : ['employee_Nr']}
      schema={useSpac ? ProfCollaborator(false) : CollaboAssistantSchema(false)}
      dataSource={assistant}>
      <Column caption={i18n2._('Nombre')} dataField="name" width={200} />
      <Column caption={i18n2._('CWID')} dataField="cwid" />
      {!useSpac ? (
        <Column
          caption={i18n2._('#Sector')}
          dataField="iD_Sector"
          visible={false}
        />
      ) : null}
      {!useSpac ? (
        <Column
          caption={i18n2._('#Perfil')}
          dataField="iD_Profile_Web"
          visible={false}
        />
      ) : null}
      {!useSpac ? (
        <Column
          caption={i18n2._('#Turno')}
          dataField="iD_Shift"
          visible={false}
        />
      ) : (
        <Column
          caption={i18n2._('Descripcion del SPAC')}
          dataField="profileDesc"
        />
      )}
      <Column caption={i18n2._('Sector')} dataField="sector_Name" />
      <Column caption={i18n2._('Perfil')} dataField="profile_Name" />
      <Column caption={i18n2._('Turno')} dataField="shift_Name" />
      <Column caption={i18n2._('Numero de empleado')} dataField="employee_Nr" />
      <Column
        caption=""
        cellComponent={(e: any) => <Buttons data={e.data.data} />}
        width={getActionColumnWidth(MAX_ACTION_BUTTONS, isTablet)}
        fixed
        alignment="right"
      />
    </IntegrityRoleGrid>
  );
};

export default CollaboratorAssistantGrid;
